export default __webpack_public_path__ + "static/media/Raider's Chestguard of the Khan.dcd69150.jpg";